import { Button, Chip, Grid } from '@material-ui/core';
import { CheckCircleRounded, Description, EventBusy, HomeWork, RadioButtonUncheckedOutlined, Room, School, Work } from '@material-ui/icons';
import { getStudentAffiliate, getBusinessContractByStudent } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { pluralize, roundToPreviousHalf } from '@webapps/utils';
import Tooltip from 'components/Tooltip';
import { useState } from 'react';
import Modal from 'components/Modal';
import BusinessContractForm from 'components/BusinessContractForm';


const AffiliateInfo = ({ id, school, absenceHours, refetch }) => {
  const { css, classes, global, cx, theme: { spacing }, } = useStyles(styles);

  const { data: { data: info = [] } = {} } = useQuery(getStudentAffiliate, {
    key: ['infoStudentBusinessAffiliate', id],
    variables: { id, type: 'business', status: 'enclosed' },
    });

  const { data: businessContract = {}, refetch: refetchBusiness } = useQuery(getBusinessContractByStudent, {
      key: ['businessContract', id],
      variables: { id },
  });

    const [openCompleteContract, setOpenCompleteContract] = useState(false);
    const [stepModal, setStepModal] = useState(1);

  return (
    <Grid container style={{ flexDirection: 'column' }}>
      <Grid className={cx(classes.address, global.infoText)} >
        <Work className={global.infoIcon} />
        <div >{info[0]?.job?.label.length >= 45 ? info[0]?.job?.label.slice(0, 45) + '...' : info[0]?.job?.label}</div>
      </Grid>
      <Grid className={cx(classes.address, global.infoText)} >
        <Description className={global.infoIcon} />
        <div>{info[0]?.contractType?.label}</div>
      </Grid>
      <Grid className={cx(classes.address, global.infoText)} >
        <HomeWork className={global.infoIcon} />
        <div>{school ? school : 'Non renseigné'}</div>
      </Grid>
      {absenceHours && <Grid className={cx(classes.address, global.infoText)}>
                    <EventBusy className={global.infoIcon} />
                    {!absenceHours.total ? 'Pas d\'absence' : `${roundToPreviousHalf(absenceHours.total / 7)} ${pluralize("jour", roundToPreviousHalf(absenceHours.total / 7))}  (${absenceHours.total} ${pluralize("heure", absenceHours.total)} d'absence)`}
                  </Grid>}
      <Grid >
        {!info[0]?.contract ? (
          <div className={classes.chipContainer} >
            {info[0]?.contractType?.label === "Alternance" && !businessContract?.cfaCompliant && businessContract?.id ? (
            <Button
              color="primary"
              onClick={() => setOpenCompleteContract(true)}
              variant="contained"
              className={classes.btn}
              >
              Contrat à remplir
          </Button>
            ) : (
            <Chip
              classes={{
                colorPrimary: css({
                  background: '#F3F7FF',
                  color: '#5D75A8',
                  lineHeight: '32px'
                }),
              }}
              className={classes.chip}
              color="primary"
              label="⚠️ Contrat en attente"
            />
          )}
          </div>
        ) : (
          <div>
            {info[0]?.contract.schoolSignAction !== null && info[0]?.contract.studentSignAction !== null && info[0]?.contract.businessSignAction !== null ? (
              <Chip
                classes={{
                  colorPrimary: css({
                    background: '#dbfad8',
                    color: 'green',
                    lineHeight: '32px'
                  }),
                }}
                className={classes.chip}
                color="primary"
                label="Contrat signé (en cours)"
              />
            ) : (
              <div>
                {
                  info[0]?.contract.schoolSignAction === null && info[0]?.contract.studentSignAction === 'SIGNED' && info[0]?.contract.businessSignAction === null ||
                    info[0]?.contract.schoolSignAction === 'SIGNED' && info[0]?.contract.studentSignAction === null && info[0]?.contract.businessSignAction === null ||
                    info[0]?.contract.schoolSignAction === null && info[0]?.contract.studentSignAction === null && info[0]?.contract.businessSignAction === 'SIGNED' ? (
                    <Chip
                      classes={{
                        colorPrimary: css({
                          background: '#FAE8D7',
                          color: '#FA8100',
                          lineHeight: '32px'
                        }),
                      }}
                      className={classes.chip}
                      color="primary"
                      label="Contrat signé 1/3"
                    />) : (info[0]?.contract.schoolSignAction === null && info[0]?.contract.studentSignAction === 'SIGNED' && info[0]?.contract.businessSignAction === 'SIGNED' ||
                      info[0]?.contract.schoolSignAction === 'SIGNED' && info[0]?.contract.studentSignAction === 'SIGNED' && info[0]?.contract.businessSignAction === null ||
                      info[0]?.contract.schoolSignAction === 'SIGNED' && info[0]?.contract.studentSignAction === null && info[0]?.contract.businessSignAction === 'SIGNED' ? (
                      <Chip
                        classes={{
                          colorPrimary: css({
                            background: '#FAE8D7',
                            color: '#FA8100',
                            lineHeight: '32px'
                          }),
                        }}
                        className={classes.chip}
                        color="primary"
                        label="Contrat signé 2/3"
                      />) : (info[0]?.contract.schoolSignAction === null && info[0]?.contract.schoolSignAction === null && info[0]?.contract.schoolSignAction === null &&
                        <Chip
                          classes={{
                            colorPrimary: css({
                              background: '#FAE8D7',
                              color: '#FA8100',
                              lineHeight: '32px'
                            }),
                          }}
                          className={classes.chip}
                          color="primary"
                          label="Contrat signé 0/3"
                        />))}
              </div>
            )}
          </div>
        )}

            </Grid>
            <Modal
                nbStep={5}
                onCancel={() => setOpenCompleteContract(false)}
                open={openCompleteContract}
                step={stepModal}
                width={800}
                title={'Données du contrat'}
            >
            <BusinessContractForm
                onChangeStepModal={setStepModal}
                businessContract={businessContract}
                onClose={() => setOpenCompleteContract(false)}
                refetch={refetchBusiness}
            />
            </Modal>
        </Grid>
    )
};

const styles = ({ spacing }) => ({
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center', width: '100%' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(1),
  },
  chip: {
    marginTop: spacing(2.5),
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    '@media only screen and (max-width:768px)': { fontSize: 12, padding: 0, maring: 0 },
  },
  chipContainer: {
    marginBottom: spacing(0),
  },
});

export default AffiliateInfo